import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { AFLDesignSystem } from '../components/AFLDesignSystem';

const AFLDesignSystemProvider = ({ store, data }) => {
    return (
        <Provider store={store}>
            <AFLDesignSystem {...data} />
        </Provider>
    );
};

export default AFLDesignSystemProvider;

AFLDesignSystemProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
